import { render } from "./xitongchushisheding.vue?vue&type=template&id=1744a511&scoped=true"
import script from "./xitongchushisheding.vue?vue&type=script&lang=js"
export * from "./xitongchushisheding.vue?vue&type=script&lang=js"

import "./xitongchushisheding.vue?vue&type=style&index=0&id=1744a511&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1744a511"]])

export default __exports__